/**
 * Backend granular middleware → `Insufficient permissions: … required.`
 * Backend rosieAuthMiddleware allowedTypes → `Access denied. Insufficient permissions.`
 * These must not trigger global Firebase sign-out — session may still be valid.
 */
// eslint-disable-next-line import/prefer-default-export -- single predicate shared with serverError.service
export function isRosieAuthorizationForbiddenMessage(
  message: string,
): boolean {
  const m = message.trim();
  if (m.startsWith('Insufficient permissions:')) return true;
  if (m.includes('Access denied. Insufficient permissions.')) return true;
  return false;
}
